import * as Types from '../../../../../__generated__/GQL';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CanUseSecurityWithStrongAuthenticationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CanUseSecurityWithStrongAuthenticationQuery = { __typename: 'Query', canUseSecurityWithStrongAuthentication: boolean };


export const CanUseSecurityWithStrongAuthenticationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CanUseSecurityWithStrongAuthentication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canUseSecurityWithStrongAuthentication"}}]}}]} as unknown as DocumentNode<CanUseSecurityWithStrongAuthenticationQuery, CanUseSecurityWithStrongAuthenticationQueryVariables>;